import React, { ReactNode, useEffect } from 'react';
import { useAuth } from './AuthContext';
import { MercadoPagoProvider } from '@/shared/context/MercadoPagoContext';

interface CompanyProtectedRouteProps {
  children: ReactNode;
}

/**
 * A wrapper for routes that require both authentication and company setup.
 * This component checks if the user has company setup completed and redirects
 * to /company-setup if needed. Only use this for routes that actually need
 * company data (like dashboard, billing, etc.).
 */
const CompanyProtectedRoute: React.FC<CompanyProtectedRouteProps> = ({ children }) => {
  const { checkAndRedirectCompanySetup, isLoggedIn } = useAuth();
  
  console.log('🏛️ CompanyProtectedRoute render:', { isLoggedIn });
  
  useEffect(() => {
    console.log('🏛️ CompanyProtectedRoute useEffect triggered:', { isLoggedIn });
    // Only check company setup if user is logged in
    if (isLoggedIn) {
      console.log('CompanyProtectedRoute: Checking company setup for logged in user');
      checkAndRedirectCompanySetup();
    } else {
      console.log('CompanyProtectedRoute: User not logged in, skipping company check');
    }
  }, [isLoggedIn, checkAndRedirectCompanySetup]);

  // Always render children wrapped in MercadoPagoProvider - the redirect happens in the useEffect if needed
  return (
    <MercadoPagoProvider>
      {children}
    </MercadoPagoProvider>
  );
};

export default CompanyProtectedRoute;
